import React, { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Text,
  Spinner,
  HStack,
  Badge,
  SimpleGrid,
} from "@chakra-ui/react";
import { useCognito } from "../utils/useCognito";
import { formatDateTime } from "../utils/dateUtils";

const IVR_STATUSES = [
  "submitted",
  "in progress",
  "signed",
  "awaiting documents",
  "approved",
  "denied",
  "completed"
];

const IvrChecker = () => {
  const [grouped, setGrouped] = useState({});
  const [loading, setLoading] = useState(true);
  const { getIdToken } = useCognito();

  useEffect(() => {
    const fetchIvrs = async () => {
      try {
        const token = getIdToken();

        const res = await fetch(
          "https://w6mxt54h5f.execute-api.us-east-2.amazonaws.com/Prod/api/getAllIvrs",
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        const data = await res.json();

        // Parse the "body" field as JSON
        const parsedBody = JSON.parse(data.body);

        setGrouped(parsedBody.grouped || {});
      } catch (err) {
        console.error("Failed to fetch IVRs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchIvrs();
  }, [getIdToken]);

  return (
    <Box p={8}>
      <Heading size="lg" mb={6}>IVR Checker</Heading>

      {loading ? (
        <Spinner size="xl" />
      ) : (
        <>
          {IVR_STATUSES.map((status) => (
            <Box key={status} mb={10}>
              <Heading size="md" mb={4}>
                {status.charAt(0).toUpperCase() + status.slice(1)} ({grouped[status]?.length || 0})
              </Heading>
              <SimpleGrid columns={[1, 2, 3]} spacing={4}>
                {(grouped[status] || []).map((ivr) => (
                  <Box key={ivr.ivrId} p={4} borderWidth={1} borderRadius="md">
                    <HStack justify="space-between">
                      <Text fontWeight="bold">IVR ID: {ivr.ivrId}</Text>
                      <Badge colorScheme="teal">{ivr.status}</Badge>
                    </HStack>
                    <Text mt={2}>Updated: {formatDateTime(ivr.updatedAt)}</Text>
                    <Text>Physician: {ivr.physician?.name || "N/A"}</Text>
                    <Text>Facility: {ivr.facility?.name || "N/A"}</Text>
                  </Box>
                ))}
              </SimpleGrid>
            </Box>
          ))}
        </>
      )}
    </Box>
  );
};

export default IvrChecker;